import React, { useEffect, useRef, useState } from "react";
import {
    Box,
    Typography,
    Card,
    CardContent,
    CardMedia,
    Stack,
    Button,
    Grid,
    Fab,
    CircularProgress,
    Container,
    Avatar
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getSingleReport } from "../../Slices/reports";
import StudentSkillProfileChartWeb from "../../Components/reports/RadarCompetencyChart";
import UpcomingEventsCard from "../../Components/reports/UpcomingEvents";
import SkillsSummaryChart from "../../Components/reports/SkillsSummaryChart";
import ComparisonBarChart from "../../Components/reports/ComparisonBarChart";
import PopularQualifications from "../../Components/reports/PopularQualifications";
import ChildDevelopmentSuggestions from "../../Components/reports/ChildDevelopmentSuggestions";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import PastEventsCard from "../../Components/reports/PastEvents";
import CareerAIAdvisorCard from "../../Components/reports/AIAdvice";


const GradientCard = ({ gradient, children }) => (
    <Card sx={{ background: gradient, color: "#fff", borderRadius: 12 }}>
        {children}
    </Card>
);

const ReportSingle = () => {
    const token = useSelector((state) => state.auth.user?.jwt);
    const user = useSelector((state) => state.auth.user);
    const { id } = useParams();
    const [report, setReport] = useState(null);
    const viewRef = useRef();
    const containerRef = useRef()

    useEffect(() => {
        if (!token) return;
        const fetchReport = async () => {
            try {
                const res = await getSingleReport(id, token);
                setReport(res?.reportData);
            } catch (err) {
                console.error("Błąd pobierania raportu:", err);
            }
        };
        fetchReport();
    }, [id, token]);

    console.log('report3232', report)

    if (!report) return <Box sx={{
        position: "absolute",
        left: "50%",
        top: "50%"
    }}><CircularProgress /></Box>;

    const generatePdf = async () => {
        if (!containerRef.current) return;

        const canvas = await html2canvas(containerRef.current, { scale: 2 });
        // const canvas = await html2canvas(containerRef.current, {
        //     scale: 1
        // });
        // const imgData = canvas.toDataURL("image/png");
        const imgData = canvas.toDataURL("image/jpeg", 1);

        // const pdf = new jsPDF("p", "mm", "a4");
        const pdf = new jsPDF({
            orientation: "p",
            unit: "mm",
            format: "a4",
            compress: true
        });
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        const imgProps = pdf.getImageProperties(imgData);
        const imgWidth = imgProps.width;
        const imgHeight = imgProps.height;

        const scaledWidth = pdfWidth;
        const scaledHeight = (imgHeight * pdfWidth) / imgWidth;

        let position = 0;

        if (scaledHeight <= pdfHeight) {
            pdf.addImage(imgData, "PNG", 0, 0, scaledWidth, scaledHeight);
        } else {
            let remainingHeight = scaledHeight;
            let y = 0;

            while (remainingHeight > 0) {
                const pageHeight = Math.min(remainingHeight, pdfHeight);
                pdf.addImage(
                    imgData,
                    "PNG",
                    0,
                    -y,
                    scaledWidth,
                    scaledHeight
                );

                remainingHeight -= pdfHeight;
                y += pdfHeight;

                if (remainingHeight > 0) pdf.addPage();
            }
        }

        pdf.save("raport.pdf");
    };

    console.log('report', report)
    console.log('user', user)

    return (
        <Container ref={containerRef} maxWidth="lg" sx={{ mt: 8 }}>
            <Box ref={viewRef} sx={{ p: 4, bgcolor: "#f7f7f7", minHeight: "100vh", borderRadius: '18px' }}>
                {/* <Typography variant="h4" mb={3}>
                RAPORT RODZICA
            </Typography> */}

                <Typography variant="h4" mb={3} sx={{ justifySelf: 'center' }}>Ścieżka kompetencyjna Twojego dziecka</Typography>

                <Card sx={{ mb: 3, p: 2, borderRadius: '18px' }}>

                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            mb: 6,
                        }}
                    >
                        <Avatar
                            sx={{
                                width: 80,
                                height: 80,
                                mb: 2,
                            }}
                        >
                            {report?.user?.name?.charAt(0)?.toUpperCase() ?? ""}
                        </Avatar>

                        <Typography variant="h6">
                            {report?.user?.name ?? ""}
                        </Typography>
                    </Box>

                    <Typography variant="h6" sx={{ mb: 3, textAlign: 'center' }}>Mikropoświadczenia Twojego dziecka</Typography>


                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                            <GradientCard gradient="linear-gradient(135deg, #FFD700, #FFA500)">
                                <CardContent sx={{ textAlign: "center", py: 4 }}>
                                    <Typography variant="subtitle1">Złote odznaki (Kwalifikacje)</Typography>
                                    <CardMedia
                                        component="img"
                                        image="/assets/badge_gold.png"
                                        alt="Złote odznaki"
                                        sx={{ width: 80, height: 80, mx: "auto", mt: 2 }}
                                    />
                                    <Typography variant="h3" sx={{ mt: 1, fontWeight: 700 }}>
                                        {report?.earnedCredsGold ?? 0}
                                    </Typography>
                                </CardContent>
                            </GradientCard>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <GradientCard gradient="linear-gradient(135deg, #C0C0C0, #A9A9A9)">
                                <CardContent sx={{ textAlign: "center", py: 4 }}>
                                    <Typography variant="subtitle1">Srebrne odznaki – osiągnięcia własne</Typography>
                                    <CardMedia
                                        component="img"
                                        image="/assets/badge_silver.png"
                                        alt="Srebrne odznaki"
                                        sx={{ width: 80, height: 80, mx: "auto", mt: 2 }}
                                    />
                                    <Typography variant="h3" sx={{ mt: 1, fontWeight: 700 }}>
                                        {report?.earnedCredsSilver ?? 0}
                                    </Typography>
                                </CardContent>
                            </GradientCard>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <GradientCard gradient="linear-gradient(135deg, #CD7F32, #8B4513)">
                                <CardContent sx={{ textAlign: "center", py: 4 }}>
                                    <Typography variant="subtitle1">Brązowe odznaki – VR</Typography>
                                    <CardMedia
                                        component="img"
                                        image="/assets/badge_brown.png"
                                        alt="Brązowe odznaki"
                                        sx={{ width: 80, height: 80, mx: "auto", mt: 2 }}
                                    />
                                    <Typography variant="h3" sx={{ mt: 1, fontWeight: 700 }}>
                                        {report?.earnedCredsBronze ?? 0}
                                    </Typography>
                                </CardContent>
                            </GradientCard>
                        </Grid>
                    </Grid>


                    <Typography variant="h6" mb={2} mt={4}>Szczegóły odznak</Typography>
                    <Stack spacing={2}>
                        {report?.badges?.map((badge) => (
                            <Card elevation={0} key={badge.id} sx={{ p: 2, display: "flex", gap: 2, borderBottom: '2px solid #e3e3e3ff', borderRadius: 0 }}>
                                <CardMedia
                                    component="img"
                                    src={badge.image?.url}
                                    alt={badge.badgeName}
                                    sx={{ width: 60, height: 66, borderRadius: 1 }}
                                />
                                <Box sx={{ flex: 1 }}>
                                    <Typography variant="subtitle1" fontWeight={700}>{badge.badgeName}</Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        Typ: {badge.badgeType ?? "—"} | Status: {badge.status ?? "—"}
                                    </Typography>
                                    {badge.prkLevel && (
                                        <Typography variant="body2" color="text.secondary">Poziom PRK: {badge.prkLevel}</Typography>
                                    )}
                                    {badge.qualificationName && (
                                        <Typography variant="body2" color="text.secondary">Kwalifikacja: {badge.qualificationName}</Typography>
                                    )}
                                    {badge.expirationDate && (
                                        <Typography variant="body2" color="text.secondary">
                                            Wygasa: {new Date(badge.expirationDate).toLocaleDateString()}
                                        </Typography>
                                    )}
                                </Box>
                            </Card>
                        ))}
                    </Stack>

                </Card>


                <Card sx={{ mb: 3, p: 2, borderRadius: '18px' }}>
                    <Typography variant="h6">Efekty uczenia się (umiejętności) Twojego dziecka</Typography>
                    <SkillsSummaryChart skills={report.skillsSumarize} />
                </Card>
                {/* <Card sx={{ mb: 3, p: 2 }}>
                <Typography variant="h6">Efekty uczenia się (umiejętności) Twojego dziecka</Typography>
                <Typography variant="subtitle2">Twarde:</Typography>
                <Typography>{report.skillsSumarize?.hardSkills ?? "Brak danych"}</Typography>
                <Typography variant="subtitle2" mt={1}>Miękkie:</Typography>
                <Typography>{report.skillsSumarize?.softSkills ?? "Brak danych"}</Typography>
            </Card> */}

                <Card sx={{ mb: 3, p: 2, borderRadius: '18px' }}>
                    <Typography variant="h6">Twoje dziecko na tle innych użytkowników micree</Typography>
                    {report.comparison ? (
                        // <>
                        //     <Typography>Liczba zdobytych odznak: {report.comparison.userTotal}</Typography>
                        //     <Typography>Średnia innych użytkowników: {report.comparison.average}</Typography>
                        // </>
                        <ComparisonBarChart comparison={report?.comparison} />
                    ) : (
                        <Typography>Brak danych</Typography>
                    )}
                </Card>

                <Card sx={{ mb: 3, p: 2, borderRadius: '18px' }}>
                    <Typography variant="h6">
                        Kwalifikacje wybierane przez innych użytkowników micree
                    </Typography>
                    {/* <Stack spacing={1}>
                        {report.popularQualifications?.map((qual) => (
                            <Typography key={qual.id}>• {qual.name}</Typography>
                        )) || <Typography>Brak danych</Typography>}
                    </Stack> */}
                    <PopularQualifications popularQualifications={report?.popularQualifications} />
                </Card>


                <PastEventsCard user={user} report={report} />
                <UpcomingEventsCard user={user} />
                {/* <Card sx={{ mb: 3, p: 2 }}>
                <Typography variant="h6">
                    Wydarzenia, w których może wziąć udział Twoje dziecko w najbliższym czasie
                </Typography>
                <Stack spacing={1}>
                    {report.upcomingEvents?.map((event) => (
                        <Typography key={event.id}>• {event.name} ({event.date})</Typography>
                    )) || <Typography>Brak danych</Typography>}
                </Stack>
            </Card> */}

                <Card sx={{ mb: 3, p: 2, borderRadius: '18px' }}>
                    <Typography variant="h6">Sugestie rodzica</Typography>
                    <Typography variant="subtitle2">Dodaj sugestie rozwoju Twojego dziecka</Typography>
                    {/* <Typography>{report.advice ?? "Brak sugestii"}</Typography> */}
                    <ChildDevelopmentSuggestions reportId={id} parentSuggestions={report?.parentSuggestions} />
                </Card>



                {/* <Card sx={{ mt: 4, p: 2, borderRadius: '18px' }}>
                    <Typography variant="h6" mb={1}>Kursy i szkolenia</Typography>
                    <Typography>{report?.coursesBadges ?? "Brak danych"}</Typography>
                </Card> */}

                {/* <Box sx={{ mt: 4 }}>
                <StudentSkillProfileChartWeb skills={report?.badges} />
            </Box> */}

                <Box sx={{ mt: 4 }}>
                    <CareerAIAdvisorCard studentData={report} />
                </Box>



                <Box sx={{ display: "flex", justifyContent: "center", mt: 4, mb: 2 }}>
                    <Fab color="primary" onClick={generatePdf}><DownloadIcon /></Fab>
                </Box>
                <Typography variant="body2" align="center" color="text.secondary" mb={4} onClick={generatePdf}>
                    Pobierz raport w formacie PDF
                </Typography>

                {/* <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                    <Button variant="contained" color="primary">
                        Zobacz raport po 10 kwietnia
                    </Button>
                </Box> */}
            </Box>
        </Container>
    );
};

export default ReportSingle;



// import React, { useEffect, useRef, useState } from "react";
// import {
//     Box,
//     Typography,
//     Card,
//     CardContent,
//     CardMedia,
//     Stack,
//     Chip,
//     Button,
//     Grid,
//     Fab,
//     Paper
// } from "@mui/material";
// import DownloadIcon from "@mui/icons-material/Download";
// import { LinearProgress } from "@mui/material";
// import { styled } from "@mui/material/styles";
// // import html2pdf from "html2pdf.js";

// // import ReportsChart from "../../Components/reports/ReportsChart";
// // import SkillSummary from "../../Components/reports/SkillSummary";
// // import CareerAIAdvisorCard from "../../Components/reports/AIAdvice";
// import StudentSkillProfileChartWeb from "../../Components/reports/RadarCompetencyChart";
// import { useSelector } from "react-redux";
// import { getSingleReport } from "../../Slices/reports";
// import { useParams } from "react-router-dom";

// const GradientCard = styled(Card)(({ theme, gradient }) => ({
//     borderRadius: 12,
//     background: gradient,
//     color: "#fff",
//     position: "relative",
//     overflow: "hidden",
// }));

// const ReportSingle = () => {
//     const token = useSelector((state) => state.auth.user?.jwt);

//     const [report, setReport] = useState([]);

//     const { id } = useParams();
//     console.log('id', id)

//     useEffect(() => {
//         if (!token) return;

//         const fetchReports = async () => {
//             try {
//                 const res = await getSingleReport(id, token);
//                 setReport(res);
//             } catch (error) {
//                 console.error("Błąd pobierania raportów:", error);
//             }
//         };
//         fetchReports();
//     }, [token, id]);

//     console.log('report', report)

//     // const reportData = data?.reportData;
//     const viewRef = useRef();

//     // console.log('datadsadsa', data)

//     const generatePdf = () => {
//         const element = viewRef.current;
//         // html2pdf()
//         //     .from(element)
//         //     .set({ margin: 10, filename: "raport.pdf", html2canvas: { scale: 2 } })
//         //     .save();
//     };

//     return (
//         <Box
//             ref={viewRef}
//             sx={{
//                 p: { xs: 2, md: 4 },
//                 bgcolor: "#f7f7f7",
//                 minHeight: "100vh",
//             }}
//         >
//             {/* <SkillSummary reportData={reportData} /> */}

//             <Typography variant="h6" fontWeight={600} mt={4} mb={2}>
//                 Zdobyte odznaki
//             </Typography>
//             <Grid container spacing={2}>
//                 <Grid item xs={12} sm={4}>
//                     <GradientCard gradient="linear-gradient(135deg, #FFD700, #FFA500)">
//                         <CardContent sx={{ textAlign: "center", py: 4 }}>
//                             <Typography variant="subtitle1">
//                                 Złote odznaki (Kwalifikacje)
//                             </Typography>
//                             <CardMedia
//                                 component="img"
//                                 image="/assets/badge_gold.png"
//                                 alt="Złote odznaki"
//                                 sx={{ width: 80, height: 80, mx: "auto", mt: 2 }}
//                             />
//                             <Typography
//                                 variant="h3"
//                                 sx={{
//                                     mt: 1,
//                                     fontWeight: 700,
//                                     textShadow: "0px 2px 5px rgba(0,0,0,0.3)",
//                                 }}
//                             >
//                                 {report?.earnedCredsGold ?? 0}
//                             </Typography>
//                         </CardContent>
//                     </GradientCard>
//                 </Grid>

//                 <Grid item xs={12} sm={4}>
//                     <GradientCard gradient="linear-gradient(135deg, #C0C0C0, #A9A9A9)">
//                         <CardContent sx={{ textAlign: "center", py: 4 }}>
//                             <Typography variant="subtitle1">
//                                 Srebrne odznaki – osiągnięcia własne
//                             </Typography>
//                             <CardMedia
//                                 component="img"
//                                 image="/assets/badge_silver.png"
//                                 alt="Srebrne odznaki"
//                                 sx={{ width: 80, height: 80, mx: "auto", mt: 2 }}
//                             />
//                             <Typography
//                                 variant="h3"
//                                 sx={{
//                                     mt: 1,
//                                     fontWeight: 700,
//                                     textShadow: "0px 2px 5px rgba(0,0,0,0.3)",
//                                 }}
//                             >
//                                 {report?.earnedCredsSilver ?? 0}
//                             </Typography>
//                         </CardContent>
//                     </GradientCard>
//                 </Grid>

//                 <Grid item xs={12} sm={4}>
//                     <GradientCard gradient="linear-gradient(135deg, #CD7F32, #8B4513)">
//                         <CardContent sx={{ textAlign: "center", py: 4 }}>
//                             <Typography variant="subtitle1">
//                                 Brązowe odznaki – VR
//                             </Typography>
//                             <CardMedia
//                                 component="img"
//                                 image="/assets/badge_brown.png"
//                                 alt="Brązowe odznaki"
//                                 sx={{ width: 80, height: 80, mx: "auto", mt: 2 }}
//                             />
//                             <Typography
//                                 variant="h3"
//                                 sx={{
//                                     mt: 1,
//                                     fontWeight: 700,
//                                     textShadow: "0px 2px 5px rgba(0,0,0,0.3)",
//                                 }}
//                             >
//                                 {report?.earnedCredsBronze ?? 0}
//                             </Typography>
//                         </CardContent>
//                     </GradientCard>
//                 </Grid>
//             </Grid>

//             {/* Kursy */}
//             <Card sx={{ mt: 4, p: 2 }}>
//                 <Typography variant="h6" mb={1}>
//                     Kursy i szkolenia
//                 </Typography>
//                 <Typography>
//                     {report?.coursesBadges ?? "Brak danych"}
//                 </Typography>
//             </Card>

//             {/* Wykresy */}
//             <Box sx={{ mt: 4 }}>
//                 {/* <ReportsChart /> */}
//             </Box>

//             {/* <Box sx={{ mt: 4 }}>
//                 <StudentSkillProfileChartWeb skills={report?.badges} />
//             </Box> */}

//             {/* Lista szczegółowa odznak */}
//             <Card sx={{ mt: 4, p: 2 }}>
//                 <Typography variant="h6" mb={2}>
//                     Szczegóły odznak
//                 </Typography>
//                 <Stack spacing={2}>
//                     {report?.badges?.map((badge) => (
//                         <Card key={badge.id} sx={{ p: 2, display: "flex", gap: 2 }}>
//                             <CardMedia
//                                 component="img"
//                                 src={badge.imageUrl}
//                                 alt={badge.badgeName}
//                                 sx={{ width: 60, height: 60, borderRadius: 1 }}
//                             />
//                             <Box sx={{ flex: 1 }}>
//                                 <Typography variant="subtitle1" fontWeight={700}>
//                                     {badge.badgeName}
//                                 </Typography>
//                                 <Typography variant="body2" color="text.secondary">
//                                     Typ: {badge.badgeType ?? "—"} | Status: {badge.status ?? "—"}
//                                 </Typography>
//                                 {badge.prkLevel && (
//                                     <Typography variant="body2" color="text.secondary">
//                                         Poziom PRK: {badge.prkLevel}
//                                     </Typography>
//                                 )}
//                                 {badge.qualificationName && (
//                                     <Typography variant="body2" color="text.secondary">
//                                         Kwalifikacja: {badge.qualificationName}
//                                     </Typography>
//                                 )}
//                                 {badge.expirationDate && (
//                                     <Typography variant="body2" color="text.secondary">
//                                         Wygasa: {new Date(badge.expirationDate).toLocaleDateString()}
//                                     </Typography>
//                                 )}
//                             </Box>
//                         </Card>
//                     ))}
//                 </Stack>
//             </Card>

//             {/* AI Advisor */}
//             <Box sx={{ mt: 4 }}>
//                 {/* <CareerAIAdvisorCard studentData={reportData} /> */}
//             </Box>

//             {/* Pobierz PDF */}
//             <Box sx={{ display: "flex", justifyContent: "center", mt: 4, mb: 4 }}>
//                 <Fab color="primary" onClick={generatePdf}>
//                     <DownloadIcon />
//                 </Fab>
//             </Box>
//             <Typography variant="body2" align="center" color="text.secondary" mb={4}>
//                 Pobierz raport w formacie PDF
//             </Typography>
//         </Box>
//     );
// };

// export default ReportSingle;
